<ng-container *ngIf="!loading; else loadingTemplate">
  <ng-container
    *ngIf="formSubmissions && formSubmissions.length > 0; else noData">
    <div class="card border-0 table-container px-lg-5">
      <table class="table w-100">
        <thead>
          <tr class="align-middle">
            <th scope="col">Name</th>
            <th scope="col">Email</th>
            <th *ngIf="selectedType === 'quiz'" scope="col">Grade</th>
            <th scope="col">Date</th>
            <th scope="col"></th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let submission of formSubmissions">
            <td>
              {{ submission.user_name }}
            </td>
            <td>{{ submission.email }}</td>
            <td *ngIf="selectedType === 'quiz'">{{ submission.grade }}</td>
            <td>{{ submission.submission_date }}</td>
            <td>
              <button
                (click)="openSubmissionModal(submission.submission_id)"
                ngbTooltip="View Submission"
                class="btn btn-link color-tertiary p-1">
                <i class="bi bi-eye"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
  <ng-template #noData>
    <div class="fs-19 py-5 text-center" style="color: var(--gl-grey)">
      No Submissions
    </div>
  </ng-template>
</ng-container>
<ng-template #loadingTemplate>
  <div class="w-100" style="height: 150px; position: relative">
    <app-loader></app-loader>
  </div>
</ng-template>

<div
  *ngIf="listMeta && listMeta.totalCount > listMeta.perPage"
  class="row mt-4">
  <div class="d-flex justify-content-center">
    <ngb-pagination
      [(page)]="listMeta.currentPage"
      [pageSize]="listMeta.perPage"
      [collectionSize]="listMeta.totalCount"
      (pageChange)="changePage(listMeta.currentPage)"
      [maxSize]="5"
      [ellipses]="true"></ngb-pagination>
  </div>
</div>

<app-modal
  #submissionModal
  [modalConfig]="{
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    options: { size: 'lg' },
    titleText: 'View Submission',
    showFooter: false,
    closeOnBgClick: true,
  }"
  (isClosing)="resetModal()"
  (isDismissing)="resetModal()">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="submissionModal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <div class="px-5 py-4" *ngIf="selectedSubmissionId && formId">
    <app-proforms-form
      [formId]="formId"
      [submissionId]="selectedSubmissionId"
      [viewState]="viewStates.GRADED" />
  </div>
</app-modal>
